<template>
  <div class="admin-dashboard">
    <!-- Left-side menu -->
    <div class="sidebar">
      <h3>Admin Menu</h3>
      <router-link to="/admin" class="dashboard-link">Dashboard</router-link>
      <router-link to="/admin/product-list" class="dashboard-link">Product List</router-link>
      <router-link to="/admin/user-list" class="dashboard-link">Customer List</router-link>
      <div class="dashboard-link dropdown">
        <span>Invoice List</span>
        <div class="dropdown-content">
          <router-link to="/admin/invoice-list/paid" class="dropdown-item">Paid</router-link>
          <router-link to="/admin/invoice-list/unpaid" class="dropdown-item">UnPaid</router-link>
          <router-link to="/admin/invoice-list/proforma" class="dropdown-item">Proforma</router-link>
        </div>
      </div>
      <router-link to="/admin/update-company-info" class="dashboard-link">Company Info</router-link>
      <router-link to="/admin/about-me" class="dashboard-link">About Me</router-link>
    </div>

    <!-- Main content area -->
    <div class="main-content-admin">
      <router-view></router-view>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  setup() {
    return {};
  },
});
</script>

<style scoped>
/* Container for the entire page */
.admin-dashboard {
  display: flex;
  height: 100vh; /* Full viewport height */
  overflow: hidden; /* Prevent scrolling on the entire container */
}

/* Left-side sidebar menu */
.sidebar {
  width: 250px;
  background-color: #333;
  color: white;
  padding: 20px;
  font-family: Arial, sans-serif;
  position: fixed; /* Fix the sidebar */
  top: 35px;
  left: 0;
  bottom: 0; /* Stretch to the bottom */
  overflow-y: auto; /* Enable scrolling for the sidebar if content overflows */
}

.sidebar h3 {
  color: #fff;
  font-size: 24px;
  margin-bottom: 30px;
}

.dashboard-link {
  display: block;
  padding: 10px;
  margin: 10px 0;
  background-color: #4CAF50;
  color: white;
  font-size: 18px;
  text-decoration: none;
  border-radius: 4px;
  text-align: center;
  transition: background-color 0.3s ease, transform 0.2s ease;
}

/* Hover effect for links */
.dashboard-link:hover {
  background-color: #45a049;
  transform: scale(1.05);
}

/* Dropdown container */
.dropdown {
  position: relative;
  cursor: pointer;
}

/* Dropdown content (hidden by default) */
.dropdown-content {
  display: none;
  position: relative;
  background-color: #f9f9f9;
  margin-top: 10px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  z-index: 1;
  border-radius: 4px;
  overflow: hidden;
}

/* Dropdown items */
.dropdown-item {
  color: #333;
  padding: 10px 15px;
  text-decoration: none;
  display: block;
  font-size: 16px;
  transition: background-color 0.3s ease;
}

/* Hover effect for dropdown items */
.dropdown-item:hover {
  background-color: #f1f1f1;
}

/* Show dropdown content on hover */
.dropdown:hover .dropdown-content {
  display: block;
}

/* Main content area */
.main-content-admin {
  margin-left: 250px; /* Leave space for the fixed sidebar */
  flex-grow: 1;
  font-family: Arial, sans-serif;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  overflow-y: auto; /* Enable scrolling for the main content */
  padding: 20px;
  margin-top: 35px;
  margin-bottom: 20px;
  box-sizing: border-box; /* Include padding in height calculation */
}

/* Heading Styles */
.main-content-admin h2 {
  font-size: 30px;
  font-weight: bold;
  color: #333;
  margin-bottom: 30px;
}

/* Responsive design for smaller screens */
@media (max-width: 768px) {
  .admin-dashboard {
    flex-direction: column;
  }

  .sidebar {
    width: 100%;
    height: auto;
    position: relative;
  }

  .main-content-admin {
    margin-left: 0;
    padding: 15px;
  }

  .dashboard-link {
    font-size: 16px;
    padding: 10px;
    margin: 5px;
  }
}
</style>
